import { Component, inject, Input, OnInit, TemplateRef } from '@angular/core';
import { ModalService } from './modal.service';
import { ResponsiveService } from '@app/services/responsive.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
})
export class ModalComponent implements OnInit {
  @Input() template: TemplateRef<any> | null;
  showModal: boolean = false;
  readonly responsive = inject(ResponsiveService);

  constructor(private modalService: ModalService) {}

  ngOnInit() {
    this.modalService.showModal$.subscribe((show) => {
      this.showModal = show;
      this.template = this.modalService.component;
    });
    this.responsive.onListen();
  }

  close() {
    this.modalService.closeModal();
  }

  getId(){
    return this.responsive.isMobileSignal() ? 'modal-mobile' : 'modal-desktop';
  }
}
